module.exports = __webpack_public_path__ + "img/partner2.f075dee8.png";